export default {
  subscription: 'Subscription',
  subscriptions: 'Subscriptions',
  'subscription.feature': 'Feature',
  'subscription.features': 'Features',
  'subscription.select': 'Select',
  'subscription.selected': 'Selected',
  'subscription.title': 'Title',
  'subscription.duration': 'Payment Duration',
  'subscription.sale': 'Sale Information',
  'subscription.saleStart': 'Started at',
  'subscription.saleEnd': 'Expired at',
  'subscription.discount': 'Discount',
  'subscription.discountInfo': 'Discount {discount}',
  'subscription.info': 'Subscription Info',
  'subscription.price': 'Price',
  'subscription.notice': 'Notice',
  'subscription.users': 'Maximum of Business users',
  'subscription.usersInfo': 'Upto to {{users}} users',
  'subscription.actions.edit': 'Edit Subscriptions',
  'subscription.actions.addNew': 'Add new Subscriptions',
  'subscription.actions.manage': 'Manage Subscriptions',
  'subscription.msg.deleteConfirm': 'Are you sure to delete this subscription',
  'subscription.tags': 'Tags',
  'subscription.assigned.features': 'Assigned Features ({{count}})',
  'subscription.features.helper':
    'To create a subscription, you need to assign at least one feature. Features define the capabilities included in the subscription. Please select features from the available list or create new ones first.',
  'subscription.msg.unAssignConfirm': 'Are you sure to un-assign this Feature?',
  'subscription.msg.unAssignAllConfirm':
    'Are you sure to un-assign all Features?',
  'subscription.msg.deactivateBlocked': 'Deactivation Blocked',
  'subscription.msg.deactivateBlockedDescription':
    'You cannot deactivate this subscription because it is already in use for {{tenantName}}.',
  'subscription.actions.navigateToTenant': 'Navigate to Tenant',
};
